import { checkbox, email, phone, required, textarea, textareaRequired, file } from "./field-rules";

/**
 * * Внимание: не использовать тип number в качестве значения html-атрибута type
 * * поля ввода taxpayerId (поле ввода ИНН), поскольку это приводит к некорректной
 * * работе валидации.
 */

export default [
  {
    name: "branch",
    attrs: {
      type: "select",
      label: "Компания",
      required: true, // переопределяется
      items: [], // переопределяется
    },
    rules: [required]
  },
  {
    name: "contractList",
    attrs: {
      type: "text",
      label: "Подключаемый договор/договоры"
    }
  },
  {
    name: "email",
    attrs: {
      type: "email",
      label: "Email",
      required: true
    },
    rules: [required, email]
  },
  {
    name: "phone",
    attrs: {
      type: "tel",
      label: "Мобильный телефон",
      required: true,
      prefix: "+7"
    },
    rules: [required, phone]
  },
  {
    name: "content",
    attrs: {
      type: "textarea",
      label: "Содержание обращения",
      rows: 4, // Добавляем атрибут для количества строк
      maxlength: 1000 // Добавляем ограничение длины
    },
    rules: [textareaRequired, textarea]
  },
  {
    name: "fio",
    attrs: {
      type: "text",
      label: "ФИО",
      required: true
    },
    rules: [required]
  },
  {
    name: "file",
    attrs: {
      type: "file",
      label: "Прикрепление файлов",
      required: false,
      multiple: true
    },
    rules: [file]
  },
  {
    name: "allowDataHandling",
    attrs: {
      type: "checkbox",
      label: "Я принимаю условия пользовательского соглашения и даю согласие на обработку персональных данных",
      required: true
    },
    rules: [checkbox]
  }
];
